/**
 * @file chapters-button.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _textTrackButtonJs = require('./text-track-button.js');

var _textTrackButtonJs2 = _interopRequireDefault(_textTrackButtonJs);

var _componentJs = require('../../component.js');

var _componentJs2 = _interopRequireDefault(_componentJs);

var _textTrackMenuItemJs = require('./text-track-menu-item.js');

var _textTrackMenuItemJs2 = _interopRequireDefault(_textTrackMenuItemJs);

var _chaptersTrackMenuItemJs = require('./chapters-track-menu-item.js');

var _chaptersTrackMenuItemJs2 = _interopRequireDefault(_chaptersTrackMenuItemJs);

var _menuMenuJs = require('../../menu/menu.js');

var _menuMenuJs2 = _interopRequireDefault(_menuMenuJs);

var _utilsDomJs = require('../../utils/dom.js');

var Dom = _interopRequireWildcard(_utilsDomJs);

var _utilsFnJs = require('../../utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

var _utilsToTitleCaseJs = require('../../utils/to-title-case.js');

var _utilsToTitleCaseJs2 = _interopRequireDefault(_utilsToTitleCaseJs);

var _globalWindow = require('global/window');

var _globalWindow2 = _interopRequireDefault(_globalWindow);

/**
 * The button component for toggling and selecting chapters
 * Chapters act much differently than other text tracks
 * Cues are navigation vs. other tracks of alternative languages
 *
 * @param {Object} player  Player object
 * @param {Object=} options Object of option names and values
 * @param {Function=} ready    Ready callback function
 * @extends TextTrackButton
 * @class ChaptersButton
 */

var ChaptersButton = (function (_TextTrackButton) {
  _inherits(ChaptersButton, _TextTrackButton);

  function ChaptersButton(player, options, ready) {
    _classCallCheck(this, ChaptersButton);

    _TextTrackButton.call(this, player, options, ready);
    this.el_.setAttribute('aria-label', 'Chapters Menu');
  }

  /**
   * Allow sub components to stack CSS class names
   *
   * @return {String} The constructed class name
   * @method buildCSSClass
   */

  ChaptersButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-chapters-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
  };

  /**
   * Create a menu item for each text track
   *
   * @return {Array} Array of menu items
   * @method createItems
   */

  ChaptersButton.prototype.createItems = function createItems() {
    var items = [];

    var tracks = this.player_.textTracks();

    if (!tracks) {
      return items;
    }

    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      if (track['kind'] === this.kind_) {
        items.push(new _textTrackMenuItemJs2['default'](this.player_, {
          'track': track
        }));
      }
    }

    return items;
  };

  /**
   * Create menu from chapter buttons
   *
   * @return {Menu} Menu of chapter buttons
   * @method createMenu
   */

  ChaptersButton.prototype.createMenu = function createMenu() {
    var _this = this;

    var tracks = this.player_.textTracks() || [];
    var chaptersTrack = undefined;
    var items = this.items = [];

    for (var i = 0, _length = tracks.length; i < _length; i++) {
      var track = tracks[i];

      if (track['kind'] === this.kind_) {
        chaptersTrack = track;

        break;
      }
    }

    var menu = this.menu;
    if (menu === undefined) {
      menu = new _menuMenuJs2['default'](this.player_);
      var title = Dom.createEl('li', {
        className: 'vjs-menu-title',
        innerHTML: _utilsToTitleCaseJs2['default'](this.kind_),
        tabIndex: -1
      });
      menu.children_.unshift(title);
      Dom.insertElFirst(title, menu.contentEl());
    }

    if (chaptersTrack && chaptersTrack.cues == null) {
      chaptersTrack['mode'] = 'hidden';

      var remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(chaptersTrack);

      if (remoteTextTrackEl) {
        remoteTextTrackEl.addEventListener('load', function (event) {
          return _this.update();
        });
      }
    }

    if (chaptersTrack && chaptersTrack.cues && chaptersTrack.cues.length > 0) {
      var cues = chaptersTrack['cues'],
          cue = undefined;

      for (var i = 0, l = cues.length; i < l; i++) {
        cue = cues[i];

        var mi = new _chaptersTrackMenuItemJs2['default'](this.player_, {
          'track': chaptersTrack,
          'cue': cue
        });

        items.push(mi);

        menu.addChild(mi);
      }

      this.addChild(menu);
    }

    if (this.items.length > 0) {
      this.show();
    }

    return menu;
  };

  return ChaptersButton;
})(_textTrackButtonJs2['default']);

ChaptersButton.prototype.kind_ = 'chapters';
ChaptersButton.prototype.controlText_ = 'Chapters';

_componentJs2['default'].registerComponent('ChaptersButton', ChaptersButton);
exports['default'] = ChaptersButton;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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